module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/382.a7039439.png";